import React from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import { FormattedMessage } from 'react-intl';
import { AppMenuItemProps } from '../../AppMenuItemProps';

export const SettingsMenuItem = React.forwardRef(
  (
    { classes, onClick }: AppMenuItemProps,
    ref: React.Ref<any>
  ): JSX.Element => {
    return (
      <MenuItem
        onClick={onClick}
        data-testid="settings-menu"
        className={classes.menuItem}
        autoFocus={true}
        ref={ref}
      >
        <ListItemIcon className={classes.icon}>
          <TuneIcon />
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage id="appMenu.settings" />
        </ListItemText>
      </MenuItem>
    );
  }
);

SettingsMenuItem.displayName = 'SettingsMenuItem';
